
// Material Dashboard 2 React base styles
import colors from "assets/theme/base/colors";

// Material Dashboard 2 React helper functions
import pxToRem from "assets/theme/functions/pxToRem";
import boxShadow from "assets/theme/functions/boxShadow";

const { white, secondary, dull } = colors;

const stepIcon = {
  styleOverrides: {
    root: {
      background: dull.main,
      fill: dull.main,
      stroke: dull.main,
      strokeWidth: pxToRem(10),
      width: pxToRem(13),
      height: pxToRem(13),
      borderRadius: "50%",
      zIndex: 99,
      transition: "all 200ms linear",

      "&.Mui-active": {
        background: secondary.main,
        fill: secondary.main,
        stroke: secondary.main,
        borderColor: secondary.main,
        boxShadow: boxShadow([0, 0], [0, 2], white.main, 1),
      },

      "&.Mui-completed": {
        background: dull.main,
        fill: dull.main,
        stroke: dull.main,
        borderColor: dull.main,
        boxShadow: boxShadow([0, 0], [0, 2], white.main, 1),
      },
    },
  },
};

export default stepIcon;
